import styled from 'styled-components';

import { colors } from '@crm-framework/theme';

export const WrapperItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  & + &:before {
    display: inline-block;
    padding-right: 0.5rem;
    padding-left: 0;
    color: ${colors.DEFAULT_BORDER};
    content: '|';
  }
`;
